import { action } from 'typesafe-actions';
import { SnackbarsTypes, SnackbarInterface } from './types';

// Actions
export const setOpen = (payload: SnackbarInterface) =>
  action(SnackbarsTypes.SET_OPEN, payload);
export const setClose = (payload?: SnackbarInterface) =>
  action(SnackbarsTypes.SET_CLOSE, payload);

export const setSecondOpen = (payload: SnackbarInterface) =>
  action(SnackbarsTypes.SET_SECOND_OPEN, payload);
export const setSecondClose = (payload?: SnackbarInterface) =>
  action(SnackbarsTypes.SET_SECOND_CLOSE, payload);
